module.exports = __webpack_public_path__ + "static/media/Bryant Medium-01.5c761c72.svg";